export enum APOLLO_CLIENT_CONTEXT_ID {
  Main = 'main',
  Chat = 'chat',
  Dato = 'dato',
}
